import * as Routes from 'constants/Routes'

export default () => ({
  path: Routes.MORE_INFORMATION,
  getComponent: async function (nextState, cb) {
    const module = await import('./containers/MoreInformationContainer')
    cb(null, module.default)
  }
})
